export const commonTranslationFields = [
    'createdAt',
    'updatedAt',
    'deletedAt',
    'id',
    'anamnesisId',
    'diagnosisId',
    'doctorId',
    'fileId',
    'folderId',
    'folderFormId',
    'formId',
    'groupId',
    'insuranceCompanyId',
    'organizationId',
    'personId',
    'serviceId',
    'serviceWorkgroupId',
    'userId',
    'voucherId',
    'workerId',
    'workId',
    'workplaceId',
    'active',
    'code',
    'data',
    'date',
    'dateFrom',
    'dateTo',
    'description',
    'folder',
    'insuranceAbbr',
    'insuranceNumber',
    'insuranceType',
    'priority',
    'validFrom',
    'validTo',

    // databoxes
    'databoxId',
    'databox',
    'permissions',
    'ownerId',
    'owner',
    'order',
];

export const historyTranslationMap: { [key: string]: string } = {
    'address': 'common.address.',
    'addresses': 'person.address.fields.',
    'AnamnesisModel': 'anamnesis.fields.',
    'assessments': 'folder.voucher.nursingCarePlan.createAssessment.fields.',
    'authorizations': 'person.authorization.fields.',
    'basicInfos': 'service.serviceBasicInfoForm.',
    'billingBatches': 'billing.newSummary.batches.fields.',
    'BillingModel': 'billing.created.billingsTable.fields.',
    'billedProcedures':'billing.refused.procedures.fields.',
    'billedVisits': 'billing.refused.visits.fields.',
    'CarePlanModel': 'folder.carePlan.fields.',
    'compensation': 'voucher.compensation.fields.',
    'diagnoses': 'billing.documentDetail.otherDiagnoses.fields.',
    'documents': 'billing.documentDetail.mainInfo.',
    'dosing': 'folderMedication.fields.',
    'dosingPeriod': 'folderMedication.createDialog.dosingPeriods.',
    'ePrescriptionMedications': 'ePrescriptionMedication.medicationEntries.fields.',
    'EPrescriptionModel': 'ePrescriptions.fields.',
    'expertise': 'service.serviceType.',
    'factors': 'service.nursingDiagnoses.tabs.factors.',
    'folder': 'folder.fields.',
    'FolderDataShareModel': 'folder.dashboard.dataShare.fields.',
    'FolderFormModel': 'folder.forms.setsTable.fields.',
    'FolderMedicationModel': 'folderMedication.fields.',
    'folderMedications': 'folderMedication.fields.',
    'FolderModel': 'folder.fields.',
    'FolderNoteModel': 'folder.fields.',
    'FolderPaymentDetailsModel': 'folder.paymentDetails.fields.',
    'FolderRiskStatusModel': 'person.dashboard.riskStatus.fields.',
    'FolderStatusHistoryModel': 'folder.status.',
    'goals': 'service.nursingDiagnoses.tabs.goals.',
    'icps': 'workplace.icps.fields.',
    'insurances': 'person.insurance.fields.',
    'insuranceCompany': 'common.insuranceCompanies.fields.',
    'interventions': 'service.nursingDiagnoses.tabs.interventions.',
    'InvoiceModel': 'billing.newSummary.invoices.fields.',
    'invoices': 'billing.newSummary.invoices.fields.',
    'nursingCare': 'voucher.nursingCare.fields.',
    'performedProcedures': 'workData.performedProcedure.fields.',
    'person': 'person.fields.',
    'PersonContactModel': 'contact.fields.',
    'PersonModel': 'person.fields.',
    'position': 'common.address.',
    'prescribedMedicalProcedures': 'voucher.prescriptions.fields.',
    'primaryDiagnosis': 'billing.documentDetail.otherDiagnoses.fields.',
    'procedures': 'procedures.performed.fields.',
    'regionalStructure': 'common.address.',
    'responsiblePersons': 'workplace.responsiblePersons.fields.',
    'restrictions': 'person.restriction.fields.',
    'riskFactors': 'service.nursingDiagnoses.tabs.riskFactors.',
    'secondaryDiagnoses': 'voucher.general.secondaryDiagnoses.fields.',
    'ServiceDataShareModel': 'service.dataShare.fields.',
    'ServiceDoctorRecordTypeModel': 'service.settings.general.doctorRecordType.fields.',
    'ServiceGroupModel': 'service.settings.group.fields.',
    'ServiceLocationModel': 'service.location.fields.',
    'ServiceMedicalProcedureModel': 'service.settings.general.medicalProcedure.fields.',
    'ServiceModel': 'service.fields.',
    'ServiceNursingCareDiagnosisCodeModel': 'service.nursingDiagnoses.fields.',
    'ServiceNursingCareDiagnosisGroupModel': 'service.nursingCareDiagnosisGroup.fields.',
    'ServiceOperationalCapacityModel': 'service.settings.general.operationalCapacity.fields.',
    'ServiceOperationalReportModel': 'service.operationalReport.fields.',
    'ServicePatternModel': 'service.patterns.document.fields.',
    'ServicePaymentModel': 'service.payments.form.',
    'servicePaymentMedicalProcedures': 'servuce.payments.medicalProceduresPrices.fields.',
    'ServiceSettingsModel': 'service.settings.fields.',
    'ServiceSpecialistRecordContactTypeModel': 'service.settings.specialistRecord.contactType.fields',
    'ServiceSpecialistRecordWorkTypeModel': 'service.settings.specialistRecord.workType.fields',
    'serviceToShare': 'service.fields.',
    'serviceType': 'service.serviceType.',
    'ServiceWorkgroupModel': 'service.settings.general.workgroup.fields.',
    'symptoms': 'service.nursingDiagnoses.tabs.symptoms.',
    'VoucherModel': 'voucher.fields.',
    'workDataDoctorRecord': 'workData.doctorRecord.fields.',
    'workDataExtramuralCare': 'workData.extramuralCare.fields.',
    'workDataIntervention': 'workData.intervention.fields.',
    'workDataResiduaryCare': 'workData.residuaryCare.fields.',
    'workDataServiceRecord': 'workData.serviceRecords.fields.',
    'workDataSpecialistRecord': 'workData.specialistRecord.fields.',
    'workDataUnrealizedVisit': 'workData.unrealizedVisits.fields.',
    'workDataVisit': 'workData.visit.fields.',
    'WorkModel': 'workData.common.fields.',
    'workplace': 'workplace.fields.',
    'WorkplaceModel': 'workplace.table.fields.',
    'workplaces': 'workplace.table.fields.',

    // databoxes
    'permissions': 'database.databoxesPage.',
}
